export const saInstallsData = [
  {
    "name": "Aberfoyle Park",
    "value": 3,
    "lat": -35.0705635,
    "lng": 138.6011311
  },
  {
    "name": "Adelaide",
    "value": 140,
    "lat": -34.9281805,
    "lng": 138.5999312
  },
  {
    "name": "Adelaide Airport",
    "value": 24,
    "lat": -34.946159,
    "lng": 138.5307956
  },
  {
    "name": "Albert Park",
    "value": 1,
    "lat": -34.8762326,
    "lng": 138.5214767
  },
  {
    "name": "Alberton",
    "value": 3,
    "lat": -34.8590292,
    "lng": 138.5161266
  },
  {
    "name": "Aldinga",
    "value": 3,
    "lat": -35.2673234,
    "lng": 138.4831296
  },
  {
    "name": "Aldinga Beach",
    "value": 9,
    "lat": -35.279293,
    "lng": 138.4604028
  },
  {
    "name": "Allenby Gardens",
    "value": 3,
    "lat": -34.9016148,
    "lng": 138.5543914
  },
  {
    "name": "Andrews Farm",
    "value": 10,
    "lat": -34.6749515,
    "lng": 138.6595143
  },
  {
    "name": "Angle Vale",
    "value": 51,
    "lat": -34.6412198,
    "lng": 138.6461526
  },
  {
    "name": "Appila",
    "value": 4,
    "lat": -33.0497098,
    "lng": 138.4289329
  },
  {
    "name": "Ardrossan",
    "value": 1,
    "lat": -34.424675,
    "lng": 137.915867
  },
  {
    "name": "Ascot Park",
    "value": 1,
    "lat": -34.9909208,
    "lng": 138.5612243
  },
  {
    "name": "Ashbourne",
    "value": 1,
    "lat": -35.2873581,
    "lng": 138.7622388
  },
  {
    "name": "Ashford",
    "value": 8,
    "lat": -29.3257299,
    "lng": 151.0945365
  },
  {
    "name": "Athelstone",
    "value": 6,
    "lat": -34.8714792,
    "lng": 138.7054458
  },
  {
    "name": "Athol Park",
    "value": 2,
    "lat": -34.8560674,
    "lng": 138.5428326
  },
  {
    "name": "BIRKENHEAD",
    "value": 6,
    "lat": -34.836756,
    "lng": 138.5002312
  },
  {
    "name": "BLACKWOOD",
    "value": 7,
    "lat": -35.0223835,
    "lng": 138.6128068
  },
  {
    "name": "BORDERTOWN",
    "value": 2,
    "lat": -36.3108349,
    "lng": 140.7731808
  },
  {
    "name": "BURNSIDE",
    "value": 3,
    "lat": -34.944479,
    "lng": 138.6472958
  },
  {
    "name": "Balaklava",
    "value": 1,
    "lat": -34.1448045,
    "lng": 138.4161903
  },
  {
    "name": "Banksia Park",
    "value": 6,
    "lat": -34.8105248,
    "lng": 138.7305864
  },
  {
    "name": "Barossa Valley",
    "value": 1,
    "lat": -34.581713199999996,
    "lng": 138.99878719802487
  },
  {
    "name": "Bedford",
    "value": 2,
    "lat": -33.7791594543671,
    "lng": 150.4720542761924
  },
  {
    "name": "Bedford Park",
    "value": 16,
    "lat": -35.0233978,
    "lng": 138.5698409
  },
  {
    "name": "Belair",
    "value": 5,
    "lat": -35.0075677,
    "lng": 138.66469102861424
  },
  {
    "name": "Berri",
    "value": 2,
    "lat": -34.2854741,
    "lng": 140.6017385
  },
  {
    "name": "Beverley",
    "value": 10,
    "lat": -34.8952647,
    "lng": 138.5463394
  },
  {
    "name": "Black Forest",
    "value": 2,
    "lat": -35.02804985,
    "lng": 138.62838722305872
  },
  {
    "name": "Blair Athol",
    "value": 5,
    "lat": -34.8592373,
    "lng": 138.5965433
  },
  {
    "name": "Blakeview",
    "value": 4,
    "lat": -34.6756176,
    "lng": 138.710052
  },
  {
    "name": "Bolivar",
    "value": 2,
    "lat": -34.7715623,
    "lng": 138.5722034
  },
  {
    "name": "Bowden",
    "value": 10,
    "lat": -34.9028963,
    "lng": 138.5799792
  },
  {
    "name": "Brahma Lodge",
    "value": 3,
    "lat": -34.775875,
    "lng": 138.6530791
  },
  {
    "name": "Bridgewater",
    "value": 4,
    "lat": -35.0093879,
    "lng": 138.7623775
  },
  {
    "name": "Brighton",
    "value": 3,
    "lat": -35.0184242,
    "lng": 138.5223596
  },
  {
    "name": "Broadview",
    "value": 6,
    "lat": -34.8759436,
    "lng": 138.6150008
  },
  {
    "name": "Brompton",
    "value": 2,
    "lat": -34.8983219,
    "lng": 138.5756758
  },
  {
    "name": "Brooklyn Park",
    "value": 4,
    "lat": -34.9301049,
    "lng": 138.5447587
  },
  {
    "name": "Buckland Park",
    "value": 3,
    "lat": -34.6777748,
    "lng": 138.5387677
  },
  {
    "name": "Bungama",
    "value": 2,
    "lat": -33.1979576,
    "lng": 138.06800194375109
  },
  {
    "name": "Burra",
    "value": 1,
    "lat": -33.6713629,
    "lng": 138.9300733
  },
  {
    "name": "Burton",
    "value": 4,
    "lat": -34.7377001,
    "lng": 138.6001346
  },
  {
    "name": "Bute",
    "value": 1,
    "lat": -33.8658284,
    "lng": 138.007185
  },
  {
    "name": "Camden Park",
    "value": 2,
    "lat": -34.967136,
    "lng": 138.5414065
  },
  {
    "name": "Campbelltown",
    "value": 10,
    "lat": -34.0636914,
    "lng": 150.8206159
  },
  {
    "name": "Campbeltown",
    "value": 1,
    "lat": -34.0668614,
    "lng": 150.8144555
  },
  {
    "name": "Carrickalinga",
    "value": 2,
    "lat": -35.4240364,
    "lng": 138.3244028
  },
  {
    "name": "Cavan",
    "value": 1,
    "lat": -34.825656,
    "lng": 138.5995084
  },
  {
    "name": "Ceduna",
    "value": 1,
    "lat": -32.130567549999995,
    "lng": 133.70730954308243
  },
  {
    "name": "Cheltenham",
    "value": 1,
    "lat": -34.8675787,
    "lng": 138.5242666
  },
  {
    "name": "Christie Downs",
    "value": 4,
    "lat": -35.1272875,
    "lng": 138.4969434
  },
  {
    "name": "Christies Beach",
    "value": 3,
    "lat": -35.1395801,
    "lng": 138.4697587
  },
  {
    "name": "Clapham",
    "value": 3,
    "lat": -34.9901443,
    "lng": 138.6050177
  },
  {
    "name": "Clare",
    "value": 2,
    "lat": -33.8333914,
    "lng": 138.6120042
  },
  {
    "name": "Clarence Gardens",
    "value": 3,
    "lat": -34.9724861,
    "lng": 138.5777745
  },
  {
    "name": "Clarence Park",
    "value": 1,
    "lat": -34.9614472,
    "lng": 138.5803984
  },
  {
    "name": "Clearview",
    "value": 1,
    "lat": -34.8573872,
    "lng": 138.6137563
  },
  {
    "name": "Clements Gap",
    "value": 1,
    "lat": -33.5084391,
    "lng": 138.06444266610274
  },
  {
    "name": "Clovelly Park",
    "value": 7,
    "lat": -34.998473,
    "lng": 138.5708472
  },
  {
    "name": "Cnr Barton & Prospect Road",
    "value": 1,
    "lat": -35.3084364,
    "lng": 149.1349783
  },
  {
    "name": "Cockatoo Valley",
    "value": 1,
    "lat": -34.6306163,
    "lng": 138.8382939206051
  },
  {
    "name": "Collinswood",
    "value": 2,
    "lat": -34.8872868,
    "lng": 138.6122364
  },
  {
    "name": "Colonel Light Gardens",
    "value": 2,
    "lat": -34.9835849,
    "lng": 138.5946908
  },
  {
    "name": "Concordia",
    "value": 1,
    "lat": -34.5793389,
    "lng": 138.7929359
  },
  {
    "name": "Coromandel East",
    "value": 1,
    "lat": -35.047407,
    "lng": 138.6490488
  },
  {
    "name": "Coromandel Valley",
    "value": 1,
    "lat": -35.0450223,
    "lng": 138.6236483
  },
  {
    "name": "Cowandilla",
    "value": 2,
    "lat": -34.9324599,
    "lng": 138.5569406
  },
  {
    "name": "Crafers West",
    "value": 2,
    "lat": -35.0069818,
    "lng": 138.698113
  },
  {
    "name": "Craigburn Farm",
    "value": 2,
    "lat": -35.0374723,
    "lng": 138.6125064
  },
  {
    "name": "Craigmore",
    "value": 1,
    "lat": -34.7006365,
    "lng": 138.7095493
  },
  {
    "name": "Croydon",
    "value": 1,
    "lat": -33.8777935,
    "lng": 151.1156502
  },
  {
    "name": "Croydon Park",
    "value": 3,
    "lat": -33.8975316,
    "lng": 151.1024641
  },
  {
    "name": "Cultana",
    "value": 1,
    "lat": -32.770861,
    "lng": 137.4954673870571
  },
  {
    "name": "Cumberland park",
    "value": 1,
    "lat": -34.9720383,
    "lng": 138.5866928
  },
  {
    "name": "Currency Creek",
    "value": 1,
    "lat": -35.490876,
    "lng": 138.83428746273097
  },
  {
    "name": "DERNANCOURT",
    "value": 1,
    "lat": -34.86198,
    "lng": 138.6765806
  },
  {
    "name": "Darlington",
    "value": 1,
    "lat": -33.890862,
    "lng": 151.1932156
  },
  {
    "name": "Davoren Park",
    "value": 18,
    "lat": -34.6910694,
    "lng": 138.6683869
  },
  {
    "name": "Daw Park",
    "value": 3,
    "lat": -34.9853742,
    "lng": 138.5877817
  },
  {
    "name": "Devon Park",
    "value": 2,
    "lat": -34.8876339,
    "lng": 138.5797647
  },
  {
    "name": "Direk",
    "value": 9,
    "lat": -34.7234261,
    "lng": 138.6091055
  },
  {
    "name": "Dover Gardens",
    "value": 2,
    "lat": -35.023994,
    "lng": 138.5369482
  },
  {
    "name": "Dry Creek",
    "value": 6,
    "lat": -34.8148068,
    "lng": 138.567052
  },
  {
    "name": "Dublin",
    "value": 1,
    "lat": -34.4513918,
    "lng": 138.3497395
  },
  {
    "name": "EYRE",
    "value": 7,
    "lat": -28.4803638,
    "lng": 137.2979051
  },
  {
    "name": "Eastwood",
    "value": 2,
    "lat": -33.79,
    "lng": 151.0844444
  },
  {
    "name": "Echunga",
    "value": 1,
    "lat": -35.1035857,
    "lng": 138.7961057
  },
  {
    "name": "Edinburgh",
    "value": 37,
    "lat": -34.70880915,
    "lng": 138.62785207369055
  },
  {
    "name": "Edinburgh North",
    "value": 3,
    "lat": -34.7043026,
    "lng": 138.658179
  },
  {
    "name": "Edithburgh",
    "value": 1,
    "lat": -35.0870533,
    "lng": 137.7424327
  },
  {
    "name": "Edwardstown",
    "value": 11,
    "lat": -34.9802157,
    "lng": 138.5694275
  },
  {
    "name": "Elizabeth",
    "value": 3,
    "lat": -34.7202612,
    "lng": 138.6693371
  },
  {
    "name": "Elizabeth Downs",
    "value": 8,
    "lat": -34.6993155,
    "lng": 138.6935867
  },
  {
    "name": "Elizabeth East",
    "value": 3,
    "lat": -34.7260216,
    "lng": 138.6815148
  },
  {
    "name": "Elizabeth Grove",
    "value": 4,
    "lat": -34.7362048,
    "lng": 138.6703138
  },
  {
    "name": "Elizabeth North",
    "value": 8,
    "lat": -34.7439818,
    "lng": 138.652878
  },
  {
    "name": "Elizabeth Park",
    "value": 10,
    "lat": -34.7123891,
    "lng": 138.6852025
  },
  {
    "name": "Elizabeth South",
    "value": 3,
    "lat": -34.7202612,
    "lng": 138.6693371
  },
  {
    "name": "Elizabeth Vale",
    "value": 13,
    "lat": -34.7489643,
    "lng": 138.6676385
  },
  {
    "name": "Encounter Bay",
    "value": 2,
    "lat": -35.57341,
    "lng": 138.75155
  },
  {
    "name": "Evanston",
    "value": 4,
    "lat": -34.6205715,
    "lng": 138.7326159
  },
  {
    "name": "Evanston Gardens",
    "value": 3,
    "lat": -34.6281174,
    "lng": 138.7199248
  },
  {
    "name": "Evanston Park",
    "value": 1,
    "lat": -34.6290775,
    "lng": 138.7484014
  },
  {
    "name": "Evanston South",
    "value": 4,
    "lat": -34.6205715,
    "lng": 138.7326159
  },
  {
    "name": "Fairview Park",
    "value": 1,
    "lat": -36.8113383,
    "lng": 140.41117063990842
  },
  {
    "name": "Findon",
    "value": 2,
    "lat": -34.899463,
    "lng": 138.5314438
  },
  {
    "name": "Flinders Park",
    "value": 9,
    "lat": -35.9753602,
    "lng": 136.72277930951776
  },
  {
    "name": "Forestville",
    "value": 1,
    "lat": -33.7620891,
    "lng": 151.2150889
  },
  {
    "name": "Frederick Road",
    "value": 1,
    "lat": -34.9052555,
    "lng": 138.50551
  },
  {
    "name": "Fulham",
    "value": 2,
    "lat": -34.9273551,
    "lng": 138.5136809
  },
  {
    "name": "Fulham Gardens",
    "value": 4,
    "lat": -34.9148333,
    "lng": 138.5132516
  },
  {
    "name": "Gawler",
    "value": 8,
    "lat": -34.5973311,
    "lng": 138.7448933
  },
  {
    "name": "Gawler Belt",
    "value": 7,
    "lat": -34.571978,
    "lng": 138.7287909
  },
  {
    "name": "Gawler East",
    "value": 6,
    "lat": -34.6026825,
    "lng": 138.7644187
  },
  {
    "name": "Gawler South",
    "value": 2,
    "lat": -34.5973311,
    "lng": 138.7448933
  },
  {
    "name": "Gepps Cross",
    "value": 4,
    "lat": -34.8423859,
    "lng": 138.6044271
  },
  {
    "name": "Gilles Plains",
    "value": 7,
    "lat": -34.8500456,
    "lng": 138.6590628
  },
  {
    "name": "Gillman",
    "value": 22,
    "lat": -34.83573735,
    "lng": 138.53632974747904
  },
  {
    "name": "Glandore",
    "value": 15,
    "lat": -34.9615032,
    "lng": 138.5683445
  },
  {
    "name": "Glen Osmond",
    "value": 1,
    "lat": -34.9594803,
    "lng": 138.6489781
  },
  {
    "name": "Glenelg",
    "value": 36,
    "lat": -34.9803673,
    "lng": 138.5143342
  },
  {
    "name": "Glenelg East",
    "value": 6,
    "lat": -34.98335555,
    "lng": 138.52159270765213
  },
  {
    "name": "Glenelg North",
    "value": 10,
    "lat": -34.9687529,
    "lng": 138.5180699
  },
  {
    "name": "Glenelg South",
    "value": 3,
    "lat": -34.9803673,
    "lng": 138.5143342
  },
  {
    "name": "Glengowrie",
    "value": 15,
    "lat": -34.9873641,
    "lng": 138.5335468
  },
  {
    "name": "Glenside",
    "value": 4,
    "lat": -34.9427375,
    "lng": 138.6337521
  },
  {
    "name": "Glenside (Burnside Village Shopping Centre)",
    "value": 1,
    "lat": -34.9408734,
    "lng": 138.6416112644788
  },
  {
    "name": "Glenunga",
    "value": 2,
    "lat": -34.9505888,
    "lng": 138.6392041
  },
  {
    "name": "Globe Derby Park",
    "value": 2,
    "lat": -34.7955606,
    "lng": 138.59224086735196
  },
  {
    "name": "Glynde",
    "value": 3,
    "lat": -34.8960474,
    "lng": 138.652531
  },
  {
    "name": "Golden Grove",
    "value": 4,
    "lat": -34.7773871,
    "lng": 138.7290659
  },
  {
    "name": "Goodwood",
    "value": 3,
    "lat": -34.9510599,
    "lng": 138.5925347
  },
  {
    "name": "Grange",
    "value": 19,
    "lat": -34.8991361,
    "lng": 138.498079
  },
  {
    "name": "Greenacres",
    "value": 4,
    "lat": -34.8686048,
    "lng": 138.6281249
  },
  {
    "name": "Gumeracha",
    "value": 1,
    "lat": -34.8222238,
    "lng": 138.8866916
  },
  {
    "name": "Hackham",
    "value": 3,
    "lat": -35.1471432,
    "lng": 138.5314176
  },
  {
    "name": "Hackham West",
    "value": 3,
    "lat": -35.1419186,
    "lng": 138.5158128
  },
  {
    "name": "Hahndorf",
    "value": 6,
    "lat": -35.0288458,
    "lng": 138.8096715
  },
  {
    "name": "Hallett Cove",
    "value": 5,
    "lat": -35.0733461,
    "lng": 138.4987451301646
  },
  {
    "name": "Happy Valley",
    "value": 4,
    "lat": -35.0765679,
    "lng": 138.5757472
  },
  {
    "name": "Hawthorn",
    "value": 3,
    "lat": -34.9709849,
    "lng": 138.6041231
  },
  {
    "name": "Hawthorndene",
    "value": 1,
    "lat": -35.0214465,
    "lng": 138.6289085
  },
  {
    "name": "Hayborough",
    "value": 6,
    "lat": -35.53156695,
    "lng": 138.64452039929577
  },
  {
    "name": "Heathfield",
    "value": 2,
    "lat": -35.0253919,
    "lng": 138.7162641506003
  },
  {
    "name": "Hectorville",
    "value": 5,
    "lat": -34.8930576,
    "lng": 138.6656798
  },
  {
    "name": "Hectroville",
    "value": 1,
    "lat": -30.5343665,
    "lng": 135.6301212
  },
  {
    "name": "Hendon",
    "value": 36,
    "lat": -34.8744445,
    "lng": 138.5151719
  },
  {
    "name": "Henley Beach",
    "value": 14,
    "lat": -34.9158802,
    "lng": 138.4986953
  },
  {
    "name": "Henley Beach South",
    "value": 4,
    "lat": -34.9158802,
    "lng": 138.4986953
  },
  {
    "name": "Highbury",
    "value": 4,
    "lat": -34.8520517,
    "lng": 138.7178758
  },
  {
    "name": "Highgate",
    "value": 4,
    "lat": -34.9616443,
    "lng": 138.6216675
  },
  {
    "name": "Hillbank",
    "value": 3,
    "lat": -34.7351475,
    "lng": 138.6873019
  },
  {
    "name": "Hillcrest",
    "value": 3,
    "lat": -34.8625153,
    "lng": 138.643046
  },
  {
    "name": "Hindmarsh",
    "value": 2,
    "lat": -34.9066222,
    "lng": 138.5699532
  },
  {
    "name": "Hindmarsh Island",
    "value": 4,
    "lat": -35.52173345,
    "lng": 138.8619986146538
  },
  {
    "name": "Holden Hill",
    "value": 5,
    "lat": -34.8516117,
    "lng": 138.6722955
  },
  {
    "name": "Hope Valley",
    "value": 7,
    "lat": -34.8453721,
    "lng": 138.6960181
  },
  {
    "name": "Houghton",
    "value": 1,
    "lat": -34.8299336,
    "lng": 138.7555961
  },
  {
    "name": "Hove",
    "value": 3,
    "lat": -35.0122882,
    "lng": 138.5237052
  },
  {
    "name": "Humbug Scrub",
    "value": 1,
    "lat": -34.7209998,
    "lng": 138.8143131
  },
  {
    "name": "Huntfield Heights",
    "value": 1,
    "lat": -35.1522659,
    "lng": 138.5123303
  },
  {
    "name": "Hyde Park",
    "value": 1,
    "lat": -34.9565521,
    "lng": 138.6029363
  },
  {
    "name": "Ingle Farm",
    "value": 4,
    "lat": -34.8275823,
    "lng": 138.6454465
  },
  {
    "name": "Inman Valley",
    "value": 1,
    "lat": -35.4947954,
    "lng": 138.4574654
  },
  {
    "name": "Joslin",
    "value": 1,
    "lat": -34.8996663,
    "lng": 138.626552
  },
  {
    "name": "KINGS PARK",
    "value": 1,
    "lat": -34.9635812,
    "lng": 138.5927206
  },
  {
    "name": "Kadina",
    "value": 1,
    "lat": -33.9647842,
    "lng": 137.7158969
  },
  {
    "name": "Kangaroo Flat",
    "value": 1,
    "lat": -34.5489111,
    "lng": 138.6933084
  },
  {
    "name": "Kapunda",
    "value": 6,
    "lat": -34.339951,
    "lng": 138.915863
  },
  {
    "name": "Keith",
    "value": 1,
    "lat": -36.0984156,
    "lng": 140.3530166
  },
  {
    "name": "Kensington",
    "value": 1,
    "lat": -37.79952715,
    "lng": 144.9249114268173
  },
  {
    "name": "Kensington Gardens",
    "value": 5,
    "lat": -34.9197256,
    "lng": 138.6631867
  },
  {
    "name": "Kensington Park",
    "value": 2,
    "lat": -34.9202054,
    "lng": 138.6542962
  },
  {
    "name": "Kent Town",
    "value": 3,
    "lat": -34.9215545,
    "lng": 138.620129
  },
  {
    "name": "Keswick",
    "value": 4,
    "lat": -34.9443902,
    "lng": 138.5777753
  },
  {
    "name": "Keswick Terminal",
    "value": 4,
    "lat": -34.9362351,
    "lng": 138.5796735
  },
  {
    "name": "Kidman Park",
    "value": 4,
    "lat": -34.9122329,
    "lng": 138.5269306
  },
  {
    "name": "Kilkenny",
    "value": 4,
    "lat": -34.8791637,
    "lng": 138.5528886
  },
  {
    "name": "Kingsford",
    "value": 2,
    "lat": -33.9498935,
    "lng": 151.18196819346016
  },
  {
    "name": "Klemzig",
    "value": 3,
    "lat": -34.878967,
    "lng": 138.6386096
  },
  {
    "name": "Korunye",
    "value": 1,
    "lat": -34.5122203,
    "lng": 138.5103256
  },
  {
    "name": "Kudla",
    "value": 1,
    "lat": -34.6518403,
    "lng": 138.706644
  },
  {
    "name": "Kurralta Park",
    "value": 6,
    "lat": -34.9514285,
    "lng": 138.5669815
  },
  {
    "name": "Largs Bay",
    "value": 2,
    "lat": -34.8266187,
    "lng": 138.4935504
  },
  {
    "name": "Largs North",
    "value": 5,
    "lat": -34.8199884,
    "lng": 138.4947938
  },
  {
    "name": "Leabrook",
    "value": 1,
    "lat": -34.9296992,
    "lng": 138.6551196
  },
  {
    "name": "Lightsview",
    "value": 1,
    "lat": -34.8619547,
    "lng": 138.6273162
  },
  {
    "name": "Linden Park",
    "value": 3,
    "lat": -34.9435932,
    "lng": 138.6472732
  },
  {
    "name": "Littlehampton",
    "value": 4,
    "lat": -35.0482163,
    "lng": 138.8658568
  },
  {
    "name": "Lobethal",
    "value": 1,
    "lat": -34.9050605,
    "lng": 138.8764755
  },
  {
    "name": "Lockleys",
    "value": 8,
    "lat": -34.9250195,
    "lng": 138.5309544
  },
  {
    "name": "Lonsdale",
    "value": 3,
    "lat": -35.1066033,
    "lng": 138.4924173
  },
  {
    "name": "Loxton",
    "value": 1,
    "lat": -34.4511348,
    "lng": 140.5696644
  },
  {
    "name": "Lyndoch",
    "value": 2,
    "lat": -34.6012473,
    "lng": 138.8882999
  },
  {
    "name": "MacDonald Park",
    "value": 1,
    "lat": -34.6700071,
    "lng": 138.6407608
  },
  {
    "name": "Magill",
    "value": 2,
    "lat": -34.9090724,
    "lng": 138.6749971
  },
  {
    "name": "Mallala",
    "value": 5,
    "lat": -34.413857,
    "lng": 138.50533934419093
  },
  {
    "name": "Malvern",
    "value": 4,
    "lat": -34.9591393,
    "lng": 138.6125368
  },
  {
    "name": "Mannum",
    "value": 2,
    "lat": -34.9134482,
    "lng": 139.3125775
  },
  {
    "name": "Mansfield Park",
    "value": 3,
    "lat": -34.8565683,
    "lng": 138.5518395
  },
  {
    "name": "Marden",
    "value": 3,
    "lat": -34.8912231,
    "lng": 138.63454310505836
  },
  {
    "name": "Marino",
    "value": 3,
    "lat": -35.0526311,
    "lng": 138.51171201218935
  },
  {
    "name": "Marion",
    "value": 15,
    "lat": -35.0261988,
    "lng": 138.5459021266757
  },
  {
    "name": "Marleston",
    "value": 7,
    "lat": -34.9453435,
    "lng": 138.5616289
  },
  {
    "name": "Marryatville",
    "value": 2,
    "lat": -34.9284327,
    "lng": 138.6459965
  },
  {
    "name": "Maude",
    "value": 4,
    "lat": -34.4740821,
    "lng": 144.300715
  },
  {
    "name": "Mawson Lakes",
    "value": 4,
    "lat": -34.8104796,
    "lng": 138.6111791
  },
  {
    "name": "Maylands",
    "value": 1,
    "lat": -34.9112777,
    "lng": 138.6367026
  },
  {
    "name": "McLaren Flat",
    "value": 1,
    "lat": -35.205776,
    "lng": 138.5852975
  },
  {
    "name": "McLaren Vale",
    "value": 7,
    "lat": -35.2172617,
    "lng": 138.5416998
  },
  {
    "name": "Meadows",
    "value": 2,
    "lat": -35.1801216,
    "lng": 138.7629692
  },
  {
    "name": "Medindie",
    "value": 1,
    "lat": -34.8973232,
    "lng": 138.604937
  },
  {
    "name": "Melrose Park",
    "value": 3,
    "lat": -33.8153435,
    "lng": 151.0733298
  },
  {
    "name": "Meningie",
    "value": 1,
    "lat": -35.6891286,
    "lng": 139.3364722
  },
  {
    "name": "Middle Beach",
    "value": 2,
    "lat": -34.6072577,
    "lng": 138.4124793
  },
  {
    "name": "Middle River",
    "value": 1,
    "lat": -35.722057050000004,
    "lng": 137.095770253212
  },
  {
    "name": "Milang",
    "value": 2,
    "lat": -35.405339,
    "lng": 138.9713267
  },
  {
    "name": "Mile End",
    "value": 17,
    "lat": -34.9263377,
    "lng": 138.5711113
  },
  {
    "name": "Millswood",
    "value": 1,
    "lat": -34.9572425,
    "lng": 138.5894966
  },
  {
    "name": "Miravale",
    "value": 1,
    "lat": -30.5343665,
    "lng": 135.6301212
  },
  {
    "name": "Mitcham",
    "value": 4,
    "lat": -34.9842362,
    "lng": 138.6230072
  },
  {
    "name": "Mitchell Park",
    "value": 6,
    "lat": -35.0050596,
    "lng": 138.5623283
  },
  {
    "name": "Moana",
    "value": 1,
    "lat": -35.1974742,
    "lng": 138.4730721
  },
  {
    "name": "Modbury",
    "value": 7,
    "lat": -34.8338962,
    "lng": 138.6851156
  },
  {
    "name": "Modbury North",
    "value": 15,
    "lat": -34.8231427,
    "lng": 138.6811612
  },
  {
    "name": "Montacute",
    "value": 1,
    "lat": -34.8820492,
    "lng": 138.78664074915218
  },
  {
    "name": "Morphett Vale",
    "value": 14,
    "lat": -35.1207525,
    "lng": 138.5239735
  },
  {
    "name": "Morphettville",
    "value": 5,
    "lat": -34.9763419,
    "lng": 138.5423417466435
  },
  {
    "name": "Mount Barker",
    "value": 75,
    "lat": -35.0641302,
    "lng": 138.8586385
  },
  {
    "name": "Mount Barker Springs",
    "value": 1,
    "lat": -35.0910535,
    "lng": 138.9197507
  },
  {
    "name": "Mount Barker Summit",
    "value": 1,
    "lat": -35.0692046,
    "lng": 138.9215505
  },
  {
    "name": "Mount Compass",
    "value": 2,
    "lat": -35.3481504,
    "lng": 138.6205654
  },
  {
    "name": "Mount Torrens",
    "value": 1,
    "lat": -34.873801,
    "lng": 138.9599686
  },
  {
    "name": "Mt Barker",
    "value": 2,
    "lat": -35.0644701,
    "lng": 138.8597928798076
  },
  {
    "name": "Munno Para",
    "value": 16,
    "lat": -34.6655937,
    "lng": 138.6900298
  },
  {
    "name": "Munno Para Downs",
    "value": 5,
    "lat": -34.6474017,
    "lng": 138.6860821
  },
  {
    "name": "Munno Para West",
    "value": 8,
    "lat": -34.6572412,
    "lng": 138.6697638
  },
  {
    "name": "Murray Bridge",
    "value": 7,
    "lat": -35.1309451,
    "lng": 139.2651638
  },
  {
    "name": "Murray Bridge East",
    "value": 1,
    "lat": -35.117594249999996,
    "lng": 139.29217710596907
  },
  {
    "name": "Myponga Beach",
    "value": 1,
    "lat": -35.3730086,
    "lng": 138.3851379
  },
  {
    "name": "Myrtle Bank",
    "value": 3,
    "lat": -34.9605623,
    "lng": 138.6337941
  },
  {
    "name": "Nairne",
    "value": 4,
    "lat": -35.0364036,
    "lng": 138.9095876
  },
  {
    "name": "Netherby",
    "value": 2,
    "lat": -34.9704959,
    "lng": 138.6250739
  },
  {
    "name": "Netley",
    "value": 7,
    "lat": -34.9493622,
    "lng": 138.5492002
  },
  {
    "name": "New Port",
    "value": 3,
    "lat": -31.4299499,
    "lng": 152.9103525
  },
  {
    "name": "Newton",
    "value": 7,
    "lat": -34.8820277,
    "lng": 138.6824021
  },
  {
    "name": "Noarlunga Centre",
    "value": 4,
    "lat": -35.1412781,
    "lng": 138.4954718
  },
  {
    "name": "Noarlunga Downs",
    "value": 4,
    "lat": -35.1478279,
    "lng": 138.5019583
  },
  {
    "name": "North Adelaide",
    "value": 16,
    "lat": -34.9207272,
    "lng": 138.60356284898404
  },
  {
    "name": "North Haven",
    "value": 1,
    "lat": -34.7872004,
    "lng": 138.4905349
  },
  {
    "name": "North Moonta",
    "value": 1,
    "lat": -34.0449834,
    "lng": 137.59437409210446
  },
  {
    "name": "North Plympton",
    "value": 6,
    "lat": -34.9557483,
    "lng": 138.5495314
  },
  {
    "name": "North Terrace",
    "value": 2,
    "lat": -34.9207272,
    "lng": 138.60356284898404
  },
  {
    "name": "Northfield",
    "value": 3,
    "lat": -34.8483826,
    "lng": 138.6261293
  },
  {
    "name": "Norwood",
    "value": 16,
    "lat": -34.919818750000005,
    "lng": 138.6304715470726
  },
  {
    "name": "Novar Gardens",
    "value": 11,
    "lat": -34.9659834,
    "lng": 138.5316592
  },
  {
    "name": "Nuriootpa",
    "value": 8,
    "lat": -34.4693354,
    "lng": 138.9939006
  },
  {
    "name": "O'Halloran Hill",
    "value": 4,
    "lat": -35.04446315,
    "lng": 138.54605073185013
  },
  {
    "name": "O'Sullivan Beach",
    "value": 2,
    "lat": -35.1191551,
    "lng": 138.4746206
  },
  {
    "name": "Oakbank",
    "value": 1,
    "lat": -34.9839126,
    "lng": 138.8439764
  },
  {
    "name": "Oakden",
    "value": 5,
    "lat": -34.8527761,
    "lng": 138.6432901
  },
  {
    "name": "Oakden Rise",
    "value": 1,
    "lat": -34.8527761,
    "lng": 138.6432901
  },
  {
    "name": "Oaklands Park",
    "value": 6,
    "lat": -35.0066862,
    "lng": 138.544563
  },
  {
    "name": "Old Noarlunga",
    "value": 1,
    "lat": -35.1827445,
    "lng": 138.4997013
  },
  {
    "name": "Old Reynella",
    "value": 1,
    "lat": -35.0968429,
    "lng": 138.5404427
  },
  {
    "name": "One Tree Hill",
    "value": 2,
    "lat": -34.7186911,
    "lng": 138.7656403
  },
  {
    "name": "Osborne",
    "value": 28,
    "lat": -35.3483333,
    "lng": 146.7177778
  },
  {
    "name": "Ottoway",
    "value": 2,
    "lat": -34.8472738,
    "lng": 138.5357349
  },
  {
    "name": "Outer Harbour",
    "value": 12,
    "lat": -34.4693233,
    "lng": 150.9078038
  },
  {
    "name": "Ovingham",
    "value": 2,
    "lat": -34.89858,
    "lng": 138.5852619
  },
  {
    "name": "Panorama",
    "value": 2,
    "lat": -34.9998042,
    "lng": 138.5972359
  },
  {
    "name": "Para Hills",
    "value": 3,
    "lat": -34.8117394,
    "lng": 138.6556036
  },
  {
    "name": "Para Hills West",
    "value": 6,
    "lat": -34.8034564,
    "lng": 138.6443173
  },
  {
    "name": "Para Vista",
    "value": 2,
    "lat": -34.8283874,
    "lng": 138.6627709
  },
  {
    "name": "Paradise",
    "value": 2,
    "lat": -34.8710706,
    "lng": 138.6762598
  },
  {
    "name": "Parafield Gardens",
    "value": 12,
    "lat": -34.7912781,
    "lng": 138.6233548
  },
  {
    "name": "Paralowie",
    "value": 12,
    "lat": -34.7570514,
    "lng": 138.6081109
  },
  {
    "name": "Park Holme",
    "value": 5,
    "lat": -34.9889082,
    "lng": 138.5521769
  },
  {
    "name": "Parkside",
    "value": 4,
    "lat": -34.9462533,
    "lng": 138.6166434
  },
  {
    "name": "Pasadena",
    "value": 4,
    "lat": -35.0027228,
    "lng": 138.5886214
  },
  {
    "name": "Payneham",
    "value": 1,
    "lat": -34.8989089,
    "lng": 138.6422239
  },
  {
    "name": "Penfield",
    "value": 14,
    "lat": -34.6916809,
    "lng": 138.6204389
  },
  {
    "name": "Penfield Gardens",
    "value": 2,
    "lat": -34.662528699999996,
    "lng": 138.61870014409175
  },
  {
    "name": "Pennington",
    "value": 4,
    "lat": -34.8575565,
    "lng": 138.5316591
  },
  {
    "name": "Plympton",
    "value": 10,
    "lat": -34.9620679,
    "lng": 138.554884
  },
  {
    "name": "Plympton Park",
    "value": 1,
    "lat": -34.9759315,
    "lng": 138.5514765
  },
  {
    "name": "Pooraka",
    "value": 7,
    "lat": -34.8257023,
    "lng": 138.6228595
  },
  {
    "name": "Port Adelaide",
    "value": 25,
    "lat": -34.8342755,
    "lng": 138.5123548
  },
  {
    "name": "Port Broughton",
    "value": 1,
    "lat": -33.6004217,
    "lng": 137.9311455
  },
  {
    "name": "Port Germein",
    "value": 1,
    "lat": -33.0205285,
    "lng": 137.9993185
  },
  {
    "name": "Port Noarlunga",
    "value": 4,
    "lat": -35.1500622,
    "lng": 138.4698986
  },
  {
    "name": "Port Noarlunga South",
    "value": 2,
    "lat": -35.1500622,
    "lng": 138.4698986
  },
  {
    "name": "Port Pirie",
    "value": 1,
    "lat": -33.1791249,
    "lng": 138.0058614
  },
  {
    "name": "Port Wakefield",
    "value": 2,
    "lat": -34.1853492,
    "lng": 138.1553794
  },
  {
    "name": "Prospect",
    "value": 36,
    "lat": -34.8827359,
    "lng": 138.5928622
  },
  {
    "name": "Prospect Hill",
    "value": 1,
    "lat": -33.8215216,
    "lng": 150.915315
  },
  {
    "name": "Queenstown",
    "value": 3,
    "lat": -34.8609515,
    "lng": 138.5103602
  },
  {
    "name": "Redwood Park",
    "value": 1,
    "lat": -34.8115495,
    "lng": 138.7069525
  },
  {
    "name": "Regency Park",
    "value": 9,
    "lat": -34.8625388,
    "lng": 138.5723971
  },
  {
    "name": "Reid",
    "value": 2,
    "lat": -34.1308958,
    "lng": 149.0086272
  },
  {
    "name": "Renmark",
    "value": 1,
    "lat": -34.1743516,
    "lng": 140.7468863
  },
  {
    "name": "Reynella",
    "value": 3,
    "lat": -35.0965682,
    "lng": 138.5216167
  },
  {
    "name": "Rhynie",
    "value": 1,
    "lat": -34.1445792,
    "lng": 138.6882751
  },
  {
    "name": "Richmond",
    "value": 1,
    "lat": -33.6009721,
    "lng": 150.7496405
  },
  {
    "name": "Ridgehaven",
    "value": 13,
    "lat": -34.821255,
    "lng": 138.7046604
  },
  {
    "name": "Riverlea Park",
    "value": 18,
    "lat": -34.6595457,
    "lng": 138.5171699
  },
  {
    "name": "Rose Park",
    "value": 1,
    "lat": -34.9307114,
    "lng": 138.6282898
  },
  {
    "name": "Rosewater",
    "value": 5,
    "lat": -34.852509,
    "lng": 138.5213144
  },
  {
    "name": "Roseworthy",
    "value": 14,
    "lat": -34.5332267,
    "lng": 138.7467051
  },
  {
    "name": "Rostrevor",
    "value": 4,
    "lat": -34.8938435,
    "lng": 138.6918266
  },
  {
    "name": "Royal Park",
    "value": 5,
    "lat": -34.11219955,
    "lng": 151.02672688004589
  },
  {
    "name": "Salisbury",
    "value": 17,
    "lat": -34.7640516,
    "lng": 138.6418765
  },
  {
    "name": "Salisbury Downs",
    "value": 3,
    "lat": -34.7717678,
    "lng": 138.6243416
  },
  {
    "name": "Salisbury East",
    "value": 11,
    "lat": -34.7764785,
    "lng": 138.6721978
  },
  {
    "name": "Salisbury Heights",
    "value": 2,
    "lat": -34.762779,
    "lng": 138.6837193
  },
  {
    "name": "Salisbury North",
    "value": 14,
    "lat": -34.745959,
    "lng": 138.6276437
  },
  {
    "name": "Salisbury Park",
    "value": 5,
    "lat": -34.7587077,
    "lng": 138.6682306
  },
  {
    "name": "Salisbury Plain",
    "value": 4,
    "lat": -34.767408,
    "lng": 138.6606036
  },
  {
    "name": "Salisbury Plains",
    "value": 2,
    "lat": -30.8038,
    "lng": 151.6071
  },
  {
    "name": "Salisbury South",
    "value": 14,
    "lat": -34.7640516,
    "lng": 138.6418765
  },
  {
    "name": "Sandy Creek",
    "value": 3,
    "lat": -31.8955,
    "lng": 145.3851
  },
  {
    "name": "Seacliff",
    "value": 6,
    "lat": -35.0322783,
    "lng": 138.5205924
  },
  {
    "name": "Seacliff Park",
    "value": 2,
    "lat": -35.0426562,
    "lng": 138.5294554
  },
  {
    "name": "Seacombe Gardens",
    "value": 4,
    "lat": -35.0233558,
    "lng": 138.5457983
  },
  {
    "name": "Seacombe Heights",
    "value": 4,
    "lat": -35.0337432,
    "lng": 138.5461915
  },
  {
    "name": "Seaford",
    "value": 5,
    "lat": -35.1868004,
    "lng": 138.4770511
  },
  {
    "name": "Seaford Heights",
    "value": 6,
    "lat": -35.197205600000004,
    "lng": 138.4971771347374
  },
  {
    "name": "Seaton",
    "value": 11,
    "lat": -34.893357,
    "lng": 138.5129598
  },
  {
    "name": "Seaview Downs",
    "value": 4,
    "lat": -35.04215,
    "lng": 138.5383393
  },
  {
    "name": "Sefton Park",
    "value": 1,
    "lat": -34.8762055,
    "lng": 138.6065036
  },
  {
    "name": "Sellicks Beach",
    "value": 4,
    "lat": -35.3316965,
    "lng": 138.4497761
  },
  {
    "name": "Semaphore",
    "value": 3,
    "lat": -34.8389194,
    "lng": 138.4839777
  },
  {
    "name": "Semaphore Park",
    "value": 4,
    "lat": -34.8558053,
    "lng": 138.4850672
  },
  {
    "name": "Semaphore South",
    "value": 2,
    "lat": -34.8389194,
    "lng": 138.4839777
  },
  {
    "name": "Sheidow Park",
    "value": 6,
    "lat": -35.0792116,
    "lng": 138.5273915
  },
  {
    "name": "Smithfield",
    "value": 7,
    "lat": -34.6848432,
    "lng": 138.686233
  },
  {
    "name": "Smithfield Plains",
    "value": 5,
    "lat": -34.676735,
    "lng": 138.676858
  },
  {
    "name": "Somerton Park",
    "value": 9,
    "lat": -34.9964662,
    "lng": 138.5198411
  },
  {
    "name": "South Brighton",
    "value": 4,
    "lat": -35.0184242,
    "lng": 138.5223596
  },
  {
    "name": "South Plympton",
    "value": 4,
    "lat": -34.9737586,
    "lng": 138.5601708
  },
  {
    "name": "Springfield",
    "value": 2,
    "lat": -33.4232322,
    "lng": 151.3677115
  },
  {
    "name": "St Andrews",
    "value": 1,
    "lat": -33.8739643,
    "lng": 151.2062543
  },
  {
    "name": "St Clair",
    "value": 8,
    "lat": -33.7983333,
    "lng": 150.7844444
  },
  {
    "name": "St Georges",
    "value": 1,
    "lat": -35.118678,
    "lng": 150.60525209894485
  },
  {
    "name": "St Marys",
    "value": 5,
    "lat": -33.7650204,
    "lng": 150.7677778
  },
  {
    "name": "St Morris",
    "value": 3,
    "lat": -34.9110511,
    "lng": 138.6536206
  },
  {
    "name": "St Peters",
    "value": 7,
    "lat": -34.9049797,
    "lng": 138.6226003
  },
  {
    "name": "Stepney",
    "value": 4,
    "lat": -34.9122895,
    "lng": 138.6292554
  },
  {
    "name": "Stirling",
    "value": 1,
    "lat": -35.0047044,
    "lng": 138.7163341
  },
  {
    "name": "Stonyfell",
    "value": 2,
    "lat": -34.9341531,
    "lng": 138.6768146
  },
  {
    "name": "Strathalbyn",
    "value": 6,
    "lat": -35.2576239,
    "lng": 138.8956803
  },
  {
    "name": "Sturt",
    "value": 2,
    "lat": -34.9035083,
    "lng": 138.5352008596853
  },
  {
    "name": "Surrey Downs",
    "value": 4,
    "lat": -34.7995126,
    "lng": 138.7115211
  },
  {
    "name": "Tailem Bend",
    "value": 1,
    "lat": -35.2529335,
    "lng": 139.4533779
  },
  {
    "name": "Tanunda",
    "value": 5,
    "lat": -34.5217025,
    "lng": 138.9603091
  },
  {
    "name": "Taperoo",
    "value": 6,
    "lat": -34.8056096,
    "lng": 138.4990522
  },
  {
    "name": "Tatachilla",
    "value": 1,
    "lat": -35.2346342,
    "lng": 138.5093688
  },
  {
    "name": "Tea Tree Gully",
    "value": 4,
    "lat": -34.8018228,
    "lng": 138.7149250285815
  },
  {
    "name": "Tennyson",
    "value": 1,
    "lat": -34.8797468,
    "lng": 138.48337128870514
  },
  {
    "name": "Teringie",
    "value": 1,
    "lat": -34.9149989,
    "lng": 138.7077959
  },
  {
    "name": "Thebarton",
    "value": 16,
    "lat": -34.9151467,
    "lng": 138.5724921
  },
  {
    "name": "Tonsley",
    "value": 18,
    "lat": -35.0082318,
    "lng": 138.572569
  },
  {
    "name": "Toorak Gardens",
    "value": 3,
    "lat": -34.9333315,
    "lng": 138.6374925
  },
  {
    "name": "Torrens Park",
    "value": 1,
    "lat": -31.0501507,
    "lng": 137.8640122
  },
  {
    "name": "Torrensville",
    "value": 16,
    "lat": -34.9197846,
    "lng": 138.5597989
  },
  {
    "name": "Totness",
    "value": 8,
    "lat": -35.058516850000004,
    "lng": 138.8354081523796
  },
  {
    "name": "Tranmere",
    "value": 4,
    "lat": -34.9054949,
    "lng": 138.6621098
  },
  {
    "name": "Trott Park",
    "value": 1,
    "lat": -35.071312,
    "lng": 138.5401404
  },
  {
    "name": "Two Wells",
    "value": 6,
    "lat": -34.5952319,
    "lng": 138.5186133
  },
  {
    "name": "Unley",
    "value": 5,
    "lat": -34.9482998,
    "lng": 138.606478
  },
  {
    "name": "Unley Park",
    "value": 1,
    "lat": -34.9625522,
    "lng": 138.6014453
  },
  {
    "name": "Urrbrae",
    "value": 4,
    "lat": -34.9681485,
    "lng": 138.638607
  },
  {
    "name": "Vale Park",
    "value": 1,
    "lat": -33.160593399999996,
    "lng": 151.54407664109442
  },
  {
    "name": "Valley View",
    "value": 3,
    "lat": -34.8399353,
    "lng": 138.6607359
  },
  {
    "name": "Verdun",
    "value": 1,
    "lat": -35.0083926,
    "lng": 138.7798278
  },
  {
    "name": "Victor Harbour",
    "value": 12,
    "lat": -33.85148313255468,
    "lng": 151.21336937548892
  },
  {
    "name": "Virginia",
    "value": 21,
    "lat": -34.666952,
    "lng": 138.560977
  },
  {
    "name": "Vista",
    "value": 5,
    "lat": -34.8283874,
    "lng": 138.6627709
  },
  {
    "name": "Walkerville",
    "value": 9,
    "lat": -34.891877,
    "lng": 138.6178503
  },
  {
    "name": "Walkley Heights",
    "value": 1,
    "lat": -34.8400924,
    "lng": 138.6369976
  },
  {
    "name": "Wallaroo",
    "value": 1,
    "lat": -33.9308118,
    "lng": 137.6272608
  },
  {
    "name": "Ward Belt",
    "value": 1,
    "lat": -34.594184014228176,
    "lng": 138.70245296694208
  },
  {
    "name": "Warradale",
    "value": 4,
    "lat": -35.0073785,
    "lng": 138.5355935
  },
  {
    "name": "Wasleys",
    "value": 2,
    "lat": -34.4724743,
    "lng": 138.6836132
  },
  {
    "name": "Waterloo Corner",
    "value": 4,
    "lat": -34.7117818,
    "lng": 138.5673475
  },
  {
    "name": "Wayville",
    "value": 8,
    "lat": -34.9448147,
    "lng": 138.5914429
  },
  {
    "name": "Welland",
    "value": 1,
    "lat": -34.903885,
    "lng": 138.5587553
  },
  {
    "name": "West Beach",
    "value": 13,
    "lat": -34.9451586,
    "lng": 138.5091364
  },
  {
    "name": "West Croydon",
    "value": 9,
    "lat": -34.8890035,
    "lng": 138.5590316
  },
  {
    "name": "West Hindmarsh",
    "value": 12,
    "lat": -34.9050505,
    "lng": 138.563007
  },
  {
    "name": "West Lakes",
    "value": 3,
    "lat": -34.8759925,
    "lng": 138.4982893
  },
  {
    "name": "West Lakes Shore",
    "value": 3,
    "lat": -34.865634,
    "lng": 138.4861882
  },
  {
    "name": "Westbourne Park",
    "value": 3,
    "lat": -34.9716448,
    "lng": 138.5952464
  },
  {
    "name": "Willaston",
    "value": 2,
    "lat": -34.5863579,
    "lng": 138.7411317
  },
  {
    "name": "Willunga",
    "value": 1,
    "lat": -35.2711681,
    "lng": 138.5554231
  },
  {
    "name": "Willunga South",
    "value": 1,
    "lat": -35.3001162,
    "lng": 138.5436461
  },
  {
    "name": "Wilpena Pound",
    "value": 1,
    "lat": -31.5264564,
    "lng": 138.606148
  },
  {
    "name": "Windsor Gardens",
    "value": 5,
    "lat": -34.8655403,
    "lng": 138.6543408
  },
  {
    "name": "Wingfield",
    "value": 18,
    "lat": -34.8410235,
    "lng": 138.5610418
  },
  {
    "name": "Wirrega",
    "value": 2,
    "lat": -36.2060787,
    "lng": 140.5830612
  },
  {
    "name": "Woodcroft",
    "value": 3,
    "lat": -35.1032023,
    "lng": 138.5624215
  },
  {
    "name": "Woodville",
    "value": 1,
    "lat": -34.8795782,
    "lng": 138.5389922
  },
  {
    "name": "Woodville Gardens",
    "value": 3,
    "lat": -34.8674539,
    "lng": 138.552209
  },
  {
    "name": "Woodville North",
    "value": 3,
    "lat": -34.8660817,
    "lng": 138.541539
  },
  {
    "name": "Woodville Park",
    "value": 2,
    "lat": -34.8824134,
    "lng": 138.5463783
  },
  {
    "name": "Woodville South",
    "value": 7,
    "lat": -34.8795782,
    "lng": 138.5389922
  },
  {
    "name": "Woodville West",
    "value": 4,
    "lat": -34.8850593,
    "lng": 138.5265794
  },
  {
    "name": "Wynn Vale",
    "value": 3,
    "lat": -34.7994176,
    "lng": 138.6871415
  },
  {
    "name": "Yatala Vale",
    "value": 1,
    "lat": -34.7940132,
    "lng": 138.7405527
  },
  {
    "name": "ferryden park",
    "value": 5,
    "lat": -34.8687799,
    "lng": 138.561433
  },
  {
    "name": "kilburn",
    "value": 5,
    "lat": -34.8596902,
    "lng": 138.5855855
  }
];
